<template>
  <div>
    <div v-if="data">
      <div class="border text-center">
        <h3>Товары в заказе:</h3>
        <table class="table border">
          <tr v-for="(purchase, key) in data.application_items" :key="key">
            <td>
              {{ purchase.good_name }} / {{ purchase.sku }}
              <b>{{ (purchase.price / 100) | spaceBetweenNumber }} UZS</b>
            </td>
          </tr>
        </table>
      </div>
      <div class="border text-center">
        <div class="text-center">
          <h3><span class="text-info">ID:</span> {{ data.id }}</h3>

          <h3>
            <span class="text-info">Статус:</span>
            {{ data.application_status.title_ru }}
          </h3>

          <div class="mb-3">
            <button @click="$emit('setStep', 'client-check')" class="link">
              Редактировать данные клиента
            </button>
          </div>
          <div>
            <button
              v-if="timer <= 0"
              class="btn btn-info mw mb-3"
              @click="check()"
            >
              Проверить статус заказа
            </button>
            <div v-else>
              Ожидайте <b>{{ timer }}</b> секунд...
            </div>
          </div>
        </div>

        <div v-if="data.contract" class="mt-3">
          <a :href="data.contract.link" target="_blank">
            <h5>Скачать договор</h5></a
          >
        </div>
      </div>
      <!-- ПОДТВЕРЖДЕНИЕ -->
      <div class="border text-center" v-if="!transaction.client_confirmed">
        <h4>Подтвреждение клиента</h4>

        <div v-if="!client_confirmed">
          <button
            @click="send"
            :disabled="transaction.client_confirmed == 1"
            class="btn btn-info mw"
          >
            Подтврдить
          </button>
        </div>
        <div v-else>
          <fg-input
            :type="`number`"
            :label="`Введите код из смс, которое пришло клиенту`"
            v-model="otp"
          ></fg-input>

          <div>
            <button @click="verify" class="btn btn-info mw mb-2">
              Подтврдить смс
            </button>
          </div>
          <div>
            <button @click="client_confirmed = false" class="btn btn-error mw">
              Сбросить
            </button>
          </div>
        </div>
      </div>
      <div
        class="border text-center"
        v-if="data.application_status.key == 'COMPLETED'"
      >
        <h3>Заказ выполнен</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {},
    },
    value: {
      default: null,
    },
  },
  name: "filter",
  async created() {
    await this.check(0);
  },
  mounted() {
    setInterval(async () => {
      this.timer--;
    }, 1000);
  },
  methods: {
    async check(timer = 60) {
      console.log("timer", timer);
      this.timer = timer;

      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.data = await this.$http
        .get(
          `${partner["endpoint_url"]}applications/applications/${this.transaction.exchange_id}`,
          {
            params: {},
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          await this.createTransaction({
            system_confirmed:
              response.data.application_status.key == "COMPLETED" ? 1 : 0,
            api_result: JSON.stringify(response.data),
          });
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async send() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http
        .post(
          `${partner["endpoint_url"]}credits/applications/${this.transaction.exchange_id}/verify-store`,
          {
            dial: false,
          },
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          this.client_confirmed = true;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async verify() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http
        .post(
          `${partner["endpoint_url"]}credits/credits`,
          {
            application_id: this.transaction.exchange_id,
            code: this.otp,
          },
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then(async (response) => {
          await this.createTransaction({
            client_confirmed: 1,
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      otp: "",
      data: null,
      client_confirmed: false,
      timer: 0,
    };
  },
};
</script>

